import { Popconfirm, Tag } from 'antd';
import React from 'react';
import {
  FaCheckCircle,
  FaDownload,
  FaExclamationCircle,
  FaEye,
  FaMoneyCheckAlt,
  FaPencilAlt,
  FaRegTrashAlt,
  FaTimesCircle,
  FaUserCheck,
} from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import { TableActions } from '~/components/Table';
import moment from 'moment';
import 'moment/locale/pt-br';
import i18next from 'i18next';
import Strong from '~/components/Strong';

const statusReturn = (code) => {
  switch (code) {
    case 0:
      return <Tag>EM PREENCHIMENTO</Tag>;
    case 1:
      return <Tag color="grey">ORÇAMENTO EM ANÁLISE</Tag>;
    case 2:
      return <Tag color="green">APROVADO</Tag>;
    case 3:
      return <Tag color="red">REPROVADO</Tag>;
    case 4:
      return <Tag color="blue">FINALIZADO</Tag>;
    default:
      return 'Não possuí';
  }
};

const paymentReturn = (code) => {
  switch (code) {
    case 0:
      return (
        <FaExclamationCircle style={{ backgroundColor: 'yellow', borderRadius: '100px' }} title="PAGAMENTO EM ABERTO" />
      );
    case 1:
      return (
        <FaTimesCircle style={{ backgroundColor: 'rgb(250, 93, 93)', borderRadius: '100px' }} title="NÃO LÍQUIDADO" />
      );
    case 2:
      return (
        <FaCheckCircle style={{ backgroundColor: 'rgb(117, 233, 71)', borderRadius: '100px' }} title="LÍQUIDADO" />
      );
    default:
      return '';
  }
};

export const eventsColumns = (handleModal, handleDelete, handleModalFinancial, handleInvites, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record?.name}
            <br />
            <Strong>{i18next.t('screens:events.code')}:</Strong> {moment(record.starts_at).year() + '/' + record.id}
            <br />
            <Strong>{i18next.t('screens:Status')}:</Strong>
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {statusReturn(record.status)}
              {paymentReturn(record.payment_status)}
            </span>
            <br />
            <Strong>{i18next.t('screens:startDate')}:</Strong>{' '}
            {moment(record.starts_at).locale('pt-br').format('DD/MM/YYYY')}
            <br />
            <Strong>{i18next.t('screens:Cidade')}:</Strong>
            {record.city_id ? record.city_name + '/' + record.state_name : ''}
            <br />
            <TableActions align="center" justify="center">
              <Button size="small" title="Visualizar" onClick={() => handleModal(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@events/editInviteEmployers">
                <Button size="small" title="Convidar colaboradores" onClick={() => handleInvites(record)}>
                  <FaUserCheck />
                </Button>
              </Can>
              <Can permission="@events/editFinancialClosing">
                <Button size="small" title="Fechamento financeiro" onClick={() => handleModalFinancial(record)}>
                  <FaMoneyCheckAlt />
                </Button>
              </Can>
              <Can permission="@events/edit">
                <Button size="small" title="Editar" onClick={() => handleModal(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@events/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('screens:events.code'),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => moment(record.starts_at).year() + '/' + record.id,
    },
    {
      title: i18next.t('screens:Status'),
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => {
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {statusReturn(record.status)}
            {paymentReturn(record.payment_status)}
          </span>
        );
      },
    },
    {
      title: i18next.t('screens:startDate'),
      dataIndex: 'starts_at',
      key: 'starts_at',
      render: (_, record) => moment(record.starts_at).locale('pt-br').format('DD/MM/YYYY'), //formatar data
    },

    {
      title: i18next.t('screens:Cidade'),
      dataIndex: 'city',
      key: 'city',
      width: '300px',
      render: (_, record) => (record.city_id ? record.city_name + '/' + record.state_name : ''),
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleModal(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@events/inviteView">
            <Button size="small" title="Convidar colaboradores" onClick={() => handleInvites(record)}>
              <FaUserCheck />
            </Button>
          </Can>
          <Can permission="@events/financialClosingView">
            <Button size="small" title="Fechamento financeiro" onClick={() => handleModalFinancial(record)}>
              <FaMoneyCheckAlt />
            </Button>
          </Can>
          <Can permission="@events/edit">
            <Button size="small" title="Editar" onClick={() => handleModal(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@events/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const eventsImportColumns = (isMobile, handleImport) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record?.name}
            <br />
            <Strong>{i18next.t('screens:events.code')}:</Strong> {moment(record.starts_at).year() + '/' + record.id}
            <br />
            <Strong>{i18next.t('screens:startDate')}:</Strong>{' '}
            {moment(record.starts_at).locale('pt-br').format('DD/MM/YYYY')}
            <br />
            <TableActions align="center" justify="center">
              <Can permission="@events/edit">
                <Button size="small" title="Editar" onClick={() => handleImport(record.consigneds)}>
                  <FaDownload />
                </Button>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('screens:events.code'),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => moment(record.starts_at).year() + '/' + record.id,
    },
    {
      title: i18next.t('screens:startDate'),
      dataIndex: 'starts_at',
      key: 'starts_at',
      render: (_, record) => moment(record.starts_at).locale('pt-br').format('DD/MM/YYYY'), //formatar data
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Can permission="@events/edit">
            <Button size="small" title="Editar" onClick={() => handleImport(record.consigneds)}>
              <FaDownload />
            </Button>
          </Can>
        </TableActions>
      ),
    },
  ];
};
